export const UPDATE_DESKTOP_LAYOUT = 'UPDATE_DESKTOP_LAYOUT';
export const UPDATE_TABLET_LAYOUT = 'UPDATE_TABLET_LAYOUT';
